// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.VisualSystemPage.View'
,	[
	     'c3_shoppingextensions_visualsystempage.tpl'
	//,	 'SCView'
	,   'GlobalViews.Breadcrumb.View'
	,   'Utils'
	,   'C3.ShoppingExtensions.VisualSystemPage.Collection'
	,   'C3.ShoppingExtensions.VisualSystemPage.SubcategoryItem.View'
	,   'LiveOrder.Model'
	,   'C3.ShoppingExtensions.LoginRegister.View'
    ,   'C3.ShoppingExtensions.VisualSystemPage.ResourceMedia.View'
    ,   'C3.ShoppingExtensions.PDP.MediaTab.View'
    /*,   'c3_shoppingextensions_visualsystempage_resource_cell_view.tpl'
    ,   'Backbone.CollectionView'
    ,   'backbone_collection_view_row.tpl'*/
    ]
, function (
	       c3_shoppingextensions_visualsystempage_tpl
	//,	 SCViewModule
	,   GlobalViewsBreadcrumbView
	,   Utils
	,   Collection
	,   SubCategoryItemsView
	,   LiveOrderModel
	,   LoginRegisterView
    ,   ResourcesMediaView
    ,   MediaTabView
    /*,   resources_cell_view_tpl
    ,   BackboneCollectionView
    ,   backbone_collection_view_row_tpl*/
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_visualsystempage_tpl

	,	initialize: function (options) {
		  this.options = options;
		  this.category = options.category;
		  this.application = options.application;
		  this.configuration = options.configuration;
		  this.container = options.container;
          this.layout = options.layout;
		  this.finalSearchData = [];
          this.catagoryCollectionData = []

		    var self = this;
		   // self.render();
	    	

               this.once('afterCompositeViewRender', function ()
               {
               //	console.log('afterCompositeViewRender');
               	var collection = new Collection();
               	var catagoryCollectionData = []

                this.itemsFromSearchApiArrayFinal = []
                var itemsFromSearchApiArray = []

		    	 var currentCategoryData = this.category;
                 console.log(currentCategoryData)

                 var subCats = currentCategoryData.categories;
                 var subCatsNames = []
                 if(subCats.length > 0){
                     _.each(subCats,function(subcat){
                        subCatsNames[subCatsNames.length] = {
                            'id' : subcat.internalid,
                            'name' : subcat.name
                        }
                        //subCatsNames.push(subcat.name)
                     })
                 }
                 //console.log(subCatsNames);

				  collection.fetch({ data:{       
				        categoryid : currentCategoryData.internalid
				      } }).done(function(res) {
				     	
    				     console.log(res);
                    if(res.status == 'success')
                    {


    					//self.render();
    				     	var catagoryCollectionData = res.searchresults;
                           // this.catagoryCollectionData = catagoryCollectionData
                      //  console.log(catagoryCollectionData)
    					_.each(catagoryCollectionData,function(categoryinfo,index){
                            //console.log(categoryinfo)
    						var subCategoryItemView = new SubCategoryItemsView({
    							categoryiteminfo : categoryinfo,
                                subcatnames : subCatsNames,
    							application : self.application,
    							configuration : self.configuration,
                                currentpagepath : currentCategoryData.fullurl
    						});
    						
    						self.$('[id="visualsystem-page-content"]')
    		                //.empty()
    		                .append(subCategoryItemView.render().$el.html());
    					})
    					$('.visualsystem-loading').css('display','none')
    					self.initSlider();

                        //SMT area is being used instead of below code
                       /* var resources = res.resources;
                        var media = res.media;
                        
                       var subCategoryItemResourceMediaView = new ResourcesMediaView({
                            resourcesArr : resources,
                            MediaArr : media,
                            application : self.application,
                            configuration : self.configuration
                        });

                        self.$('[id="Visual-System-Resources-Media"]')
                        //.empty()
                        .append(subCategoryItemResourceMediaView.render().$el.html());*/
                    }
                    else
                    {
                        //No Subcats available
                        $('.visualsystem-page-content').css('display','none');
                    }    
			      });
               })

		}

	,   initSlider: function initSlider() {

			var self = this;
	      //  if(jQuery(window).width() >= 760) //using 760 due to Tablet as its showing to start from 760
          //  {
           // const { siteSettings } = this.application.getConfig();
            	
           // setTimeout(function() {
                const carousel = self.$el.find('[data-type="carousel-items"]');
                //console.log(carousel)
                const {
                    siteSettings,
                    imageSizeMapping,
                    bxSliderDefaults
                } = self.options.application.getConfig();

                if (jQuery(window).width() >= 760 && siteSettings.imagesizes) {
                    const img_min_height = (_.where(siteSettings.imagesizes, {
                        name: imageSizeMapping.thumbnail
                    })[0]).maxheight;

                    carousel
                        .find('.item-relations-related-item-thumbnail')
                        .css('minHeight', img_min_height);
                }
                

                /*if(self.catagoryCollectionData.length > 4)
                {
                  bxSliderDefaults.controls = true;
                }
                else{
                   bxSliderDefaults.controls = false;  
                }*/

                bxSliderDefaults.slideWidth = 312;
                bxSliderDefaults.controls = true;
                bxSliderDefaults.maxSlides = 4;
                bxSliderDefaults.hideControlOnEnd = true;
                bxSliderDefaults.prevText = '<a data-click="left-click" data-action="plp-visualsystempage-click" class="plp-visualsystempage carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg"></a>';
                bxSliderDefaults.nextText = '<a data-click="right-click" data-action="plp-visualsystempage-click" class="plp-visualsystempage carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';         
                
                /*bxSliderDefaults.prevText = '<a class="carousel-items-prev-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg"></a>';
                bxSliderDefaults.nextText = '<a class="carousel-items-next-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';             
                *///bxSliderDefaults.touchEnabled = false;
                
                bxSliderDefaults.infiniteLoop = false;
                //console.log(bxSliderDefaults)
                Utils.initBxSlider(carousel, bxSliderDefaults);
             // });
           // }
    }	

    ,   events: {
		'click [data-action="plus"]': 'addQuantity',
        'click [data-action="minus"]': 'removeQuantity',
        'click [data-action="item-quick-view"]': 'groupItemPopup',
        'click [data-action="show-login-register-popup"]': 'showLoginRegisterPopup',
        'click [data-action="show-video-in-popup"]':'showVideoInPopup',
        'click [data-action="show-all-visual-resources"]':'showAllResourcesMobile',
        'click [data-action="show-all-visual-media"]':'showAllMediaMobile',
        'click [data-action="plp-visualsystempage-click"]': 'arrowClicked'
	}


    ,   arrowClicked: function arrowClicked(e){
        
        const anchor = jQuery(e.currentTarget)
        ,     data_attr = anchor.attr('data-click')
        ,     sibling = anchor.siblings()

       // console.log(anchor)
       // console.log(anchor.children())
        if(data_attr == 'right-click')
        {
            //console.log(anchor.hasClass('disabled'))
            //console.log(sibling.hasClass('disabled'))
            if(anchor.hasClass('disabled'))
            {
                 //console.log(anchor.children('.right-icon-img'))
                 anchor.children('.right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
                 //$('.plp-visualsystempage.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
            }

            if(sibling.hasClass('disabled'))
            {
                //console.log(sibling.children('.left-icon-img'))
                sibling.children('.left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')                
                //$('.plp-visualsystempage.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')             
            }
            else
            {   
                sibling.children('.left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg')
                //$('.plp-visualsystempage.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg')
            }
        }
        else if(data_attr == 'left-click')
        {
            if(anchor.hasClass('disabled'))
            {
                anchor.children('.left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')
                //$('.plp-visualsystempage.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')
            
            }
            if(sibling.hasClass('disabled'))
            {
                sibling.children('.right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
                //$('.plp-visualsystempage.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
            }
            else
            {
                sibling.children('.right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg')
                //$('.plp-visualsystempage.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg')
            }
        }
       
    }   


    ,  showAllResourcesMobile: function showAllResourcesMobile(e)
        {
            var anchor = jQuery(e.currentTarget)
            ,   data_param = anchor.attr('data-parameter');

            var parentEle = $('.Visual-System-Resources .resources-cell')
            ,   children = parentEle.children()
            ,   children_length = children.length;

            if(data_param == 'show-more'){
                children.removeClass("hide-these-sections");
                $('.see-less-visual-system-resources').css('display','block');
                $('.see-all-visual-system-resources').css('display','none');
            }
            else if (data_param == 'show-less'){                
                children.addClass("hide-these-sections");
                var firstChild = children.first();
                var secondChild = children.first().next();
                firstChild.removeClass('hide-these-sections')
                secondChild.removeClass('hide-these-sections')

                $('.see-less-visual-system-resources').css('display','none');
                $('.see-all-visual-system-resources').css('display','block');
            }
        }  

    ,  showAllMediaMobile: function showAllMediaMobile(e)
        {
            console.log(e)
            var anchor = jQuery(e.currentTarget)
            ,   data_param = anchor.attr('data-parameter');

            var parentEle = $('.Visual-System-Media')
            ,   children = parentEle.children()
            ,   children_length = children.length;

            if(data_param == 'show-more'){
                children.removeClass("hide-these-sections");
                $('.see-less-visual-system-media').css('display','block');
                $('.see-all-visual-system-media').css('display','none');
            }
            else if (data_param == 'show-less'){                
                children.addClass("hide-these-sections");
                var firstChild = children.first();
                //var secondChild = children.first().next();
                firstChild.removeClass('hide-these-sections')
                //secondChild.removeClass('hide-these-sections')

                $('.see-less-visual-system-media').css('display','none');
                $('.see-all-visual-system-media').css('display','block');
            }
        }   

    ,   childViews: {
        /*'Visual.System.Resources': function(){
               
                var self = this;
                var items = this.itemsFromSearchApiArrayFinal;
                 console.log(items)
                var viewsPerRowItems = 6;

                if(Utils.isPhoneDevice())
                    viewsPerRowItems = 2;

                return new BackboneCollectionView({
                    collection: items ? items : [],
                    childView: ResourcesMacroView,
                    viewsPerRow: viewsPerRowItems,
                    cellTemplate: resources_cell_view_tpl,
                    rowTemplate: backbone_collection_view_row_tpl,
                    childViewOptions: {
                        application: self.application
                    }
                });
            },

            'Visual.System.Media': function(){
                //console.log(this.resourcesArray)
                var self = this;
                var mediaArrayData = this.mediaArray;

                var viewsPerRowItems = 4;

                if(Utils.isPhoneDevice())
                    viewsPerRowItems = 2;

                return new BackboneCollectionView({
                    collection: mediaArrayData ? mediaArrayData : [],
                    childView: MediaMacroView,
                    viewsPerRow: viewsPerRowItems,
                    cellTemplate: media_cell_view_tpl,
                    rowTemplate: backbone_collection_view_row_tpl,
                    childViewOptions: {
                        application: self.application
                    }
                });
            }*/
    }

    ,  showVideoInPopup: function showVideoInPopup(e){
            console.log('test')
            var targetEle = $(e.currentTarget)
            ,   sibling = targetEle.siblings()
            ,   siblingSrc = sibling.attr('src');

            var layout = this.layout;

            //console.log(layout)

            var mediaVew = new MediaTabView({
                siblingSrc : siblingSrc,
                application : this.application
            })
            layout.showContent(mediaVew, {showInModal: true})
        }       

	,  groupItemPopup: function(e)
	{
		var self = this;
        var $element = jQuery(e.currentTarget)
        var url = $element.attr('data-url');
        var lightboxURL = $element.attr('data-lightbox-url');
        var product = new ProductModel();
        var promise = jQuery.Deferred();
        var item = product.get('item');

        //console.log($element)
        //console.log(url)

        //var layout = this.options.layout
        var   application = this.options.application
        ,     Layout = this.container.getComponent('Layout');
        //console.log(Layout)
        
        item.fetch({
            data: {url:url},
            killerId: AjaxRequestsKiller.getKillerId(),
            pageGeneratorPreload: true
        }).then(
            // Success function
            function(data, _result, jqXhr) {
                //console.log(data)
               if (!item.isNew()) 
                {
                    if (item.get('urlcomponent') &&
                        SC.ENVIRONMENT.jsEnvironment === 'server') {
                            nsglobal.statusCode = 301;
                            nsglobal.location = Utils.addSlashToURL(product.generateUrl());
                    }
                   if (data.corrections && data.corrections.length > 0) 
                   {
                       if ( item.get('urlcomponent') &&
                           SC.ENVIRONMENT.jsEnvironment === 'server') {
                                nsglobal.statusCode = 301;
                                nsglobal.location =
                                Utils.addSlashToURL(data.corrections[0].url) +
                                product.getQuery();
                        }else 
                        {
                           var view = new GroupAddToCart({
                                application: application ,model:product
                            });
                            if (view)
                                Layout.showContent(view, {showInModal: true})
                        
                            promise.reject();
                        }
                    }
                        // self.bindModel();
                        promise.resolve();
                } 
                else if (jqXhr.status >= 500) {
                    // application.getLayout().internalError();
                    promise.reject();
                }
                else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') 
                {
                        // We just show the 404 page
                        // application.getLayout().notFound();
                        promise.reject();
                }
            },
            // Error function
            function(jqXhr) 
            {
                // this will stop the ErrorManagment module to process this error
                // as we are taking care of it
                jqXhr.preventDefault = true;
                if (jqXhr.status >= 500) {
                    // application.getLayout().internalError();
                    promise.reject();
                } else if (jqXhr.responseJSON.errorCode !== 'ERR_USER_SESSION_TIMED_OUT') {
                    // We just show the 404 page
                    // application.getLayout().notFound();
                    promise.reject();
                }
            });
            //$('#site-footer').addClass('remove-footer-positioning')
            return promise; 
	}

	, showLoginRegisterPopup: function(e)
	{
		e.stopPropagation();
            e.preventDefault();
            
            var Layout = this.application.getComponent('Layout');
            //console.log(Layout)

            var view = new LoginRegisterView({
                application: Layout.application
            });



            if (view)
            Layout.showContent(view, {showInModal: true});
	}

	,  addQuantity: function(e)
	{
		var self = this;
            //console.log(e)
            var $element = jQuery(e.currentTarget);
            var quantity_input = $element.parent().find('.item-quantity-value');
            var button_minus = $element.parent().find('.minus-button');
            var find_title_ele = $element.closest('.e2');
            var cart = this.application.getComponent('Cart');
            var lines=[];

            var itemQtyInCurrentOrder = 0;

            var liveOrder = LiveOrderModel.getInstance();
            //console.log(self.model.get('_id'))

            var internalID=quantity_input.attr("data-id");

            //console.log(internalID)
            
            var lineData=liveOrder.get('lines').filter(function(line)
            {   
                return line.get('item').get('internalid') == internalID;
            });
            
            if(lineData.length > 0)
            {
            var lineQuantity=lineData[0].get('quantity');
            itemQtyInCurrentOrder = lineQuantity;
            }

            var elementParent = $element.parent('.plus-icon');      
            //console.log(elementParent)

            var trashCane = $element.parent().find('.product-trash-tray');
            
           // console.log(find_title_ele)
            quantity_input.show();
           // button_minus.show();

            var parentEle = $element.parent('.plus-icon');
            if(!(parentEle.hasClass('expand-plus-icon')))
            parentEle.addClass('expand-plus-icon');

            find_title_ele.addClass('newly-added-css');
            
            var old_value = quantity_input.text();

             if(elementParent.hasClass('add-to-cart-buttons-opened'))
             {
            var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
            quantity_input.text(new_val);
            }
            
            var quantity = quantity_input.text();
            var internalID=quantity_input.attr("data-id");


            if(quantity == 1)
            {
                trashCane.show();
                button_minus.hide();
                quantity_input.css('text-align','left');
                
            }
            else    
            {
                 button_minus.show();
                trashCane.hide();
                quantity_input.css('text-align','center');
            }

           // console.log(quantity)
            
            if(quantity>0)
            {
                if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
                {
                    $element.text('+');
                    $element.removeClass('plus-button-additional');

                    elementParent.addClass('add-to-cart-buttons-opened');
                    elementParent.removeClass('plus-icon-additional');

                }else
                {
                    var lineData={quantity: parseFloat(1),
                                  item: {internalid: parseFloat(internalID)}
                    };
                    lines.push(lineData);
                    //console.log(lines)
                    SC.loadingIndicatorShow();
                    cart.addLines({lines: lines}).then(function() {
                        SC.loadingIndicatorHide();
                        if(!Utils.isPhoneDevice())
                        jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
                    });
                    elementParent.addClass('add-to-cart-buttons-opened');   
                }
            }
	}

	,  removeQuantity: function(e){
		const $element = jQuery(e.currentTarget);
            const quantity_input = $element.parent().find('.item-quantity-value');
            const find_title_ele = $element.closest('.e2');
            const old_value = quantity_input.text();
            const cart = this.application.getComponent('Cart');
            var lines=[];

            if(old_value==1 )
            {
                var parentEle = $element.parent('.plus-icon');
                if(parentEle.hasClass('expand-plus-icon'))
                parentEle.removeClass('expand-plus-icon');

                if(parentEle.hasClass('add-to-cart-buttons-opened'))
                parentEle.removeClass('add-to-cart-buttons-opened');

                find_title_ele.removeClass('newly-added-css');
                let new_val = parseFloat(old_value) - 1;

                if(new_val == 0)
                quantity_input.text(1);
                else
                quantity_input.text(new_val);
                
                $element.attr("style","display:none !important;");
                quantity_input.hide();
            }
            else if(old_value>1 ){
                let new_val = parseFloat(old_value) - 1;
                quantity_input.text(new_val);

                if(old_value == 2)
                {
                    var trashCane = $element.parent().find('.product-trash-tray');
                    var button_minus = $element.parent().find('.minus-button');
                    //console.log(button_minus)
                    button_minus.attr("style","display:none !important;");
                    trashCane.show();
                    quantity_input.css('text-align','left');
                    
                }
            }
            var internalID=quantity_input.attr("data-id");
            
            var liveOrder = LiveOrderModel.getInstance();
            
            var lineData=liveOrder.get('lines').filter(function(line)
            {   
                return line.get('item').get('internalid') == internalID;
            });
            var lineQuantity=lineData[0].get('quantity');
            
            if(lineQuantity==1)
                liveOrder.removeLine(
                lineData[0].set('quantity',parseFloat(lineQuantity)-1));
            else
            {
                liveOrder.updateLine(
                lineData[0].set('quantity',parseFloat(lineQuantity)-1));
                setTimeout(function(){
                    if(!Utils.isPhoneDevice())
                        jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
                }, 1000);
            }
	}	

	,	bindings: {
		}
	

		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{
			var final = this.finalSearchData


			//console.log(this.category.name)
    		var currentCategoryPage = this.category;
    		//console.log(this.finalSearchData)
			return {
				name: this.category.name,
	            // @property {String} banner
	            banner: this.category.pagebannerurl,
	            // @property {String} description
	            description: this.category.description,
	            // @property {String} pageheading
	            pageheading: this.category.pageheading || this.category.name,
	            // @property {Boolean} hasBanner
	            hasBanner: !!this.category.pagebannerurl,
	            isPhoneDevice : Utils.isPhoneDevice(),
			   isTablet : Utils.isTabletDevice(),
			   subCategories : currentCategoryPage.categories,
			   finalData : this.finalSearchData
			};
		}
	});
});
